var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.gelenval)?_c('div',{staticClass:"chip"},[_vm._v(_vm._s(_vm.gelenval))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }